import { render, staticRenderFns } from "./BsSelect.vue?vue&type=template&id=2d635ea8&scoped=true"
import script from "./BsSelect.vue?vue&type=script&lang=js"
export * from "./BsSelect.vue?vue&type=script&lang=js"
import style0 from "./BsSelect.vue?vue&type=style&index=0&id=2d635ea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d635ea8",
  null
  
)

export default component.exports